enum TransmitFrequency {
    IMMEDIATELY,
    BATCH,
}

export default TransmitFrequency;
